import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementsEstablishConnections } from '@api/networkElements';

import { actionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_ESTABLISHED_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsEstablishedReturned {
	establishedOptions: TSelectOption[];
	isLoadingEstablishedOptions: boolean;
}

const useQueryNetworkElementsEstablished = (): IUseQueryNetworkElementsEstablishedReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_ESTABLISHED_OPTIONS],
		select: actionsFormatted,
		queryFn: getNetworkElementsEstablishConnections,
		...refetchOptions,
	});

	return {
		establishedOptions: data || [],
		isLoadingEstablishedOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementsEstablished;
